export default {
  "component.tagSelect.expand": "展开",
  "component.tagSelect.collapse": "收起",
  "component.tagSelect.all": "全部",
  "component.agentLevel.platform": "平台",
  "component.agentLevel.level1": "一级代理",
  "component.agentLevel.level2": "二级代理",
  "component.agentLevel.merchant": "商户",
  "component.xterm.status.idle": "空闲",
  "component.xterm.status.connecting": "连接中",
  "component.xterm.status.running": "运行中",
  "component.xterm.status.completed": "已完成",
  "component.xterm.status.error": "异常",
  "component.worldMap.noData": "暂无地图数据",
  "component.worldMap.loading": "地图加载中...",
};
